<div [class]="'custom-datepicker icon-' + iconPosition">
    <div class="icon-datepicker"></div>

    @if (isRange) {
        <mat-date-range-input [formGroup]="form" [rangePicker]="datePicker" (click)="datePicker.open()">
            <input
                matStartDate
                formControlName="startDate"
                [placeholder]="'placeholder.startDate' | translate"
                (dateChange)="onDateChange()" />
            <input
                matEndDate
                formControlName="endDate"
                [placeholder]="'placeholder.endDate' | translate"
                (dateChange)="onDateChange()" />
        </mat-date-range-input>
        <mat-date-range-picker #datePicker></mat-date-range-picker>
    } @else {
        <input
            type="text"
            class="date-input"
            matInput
            formControlName="date"
            readonly
            [matDatepicker]="datePicker"
            (click)="datePicker.open()" />
        <mat-datepicker #datePicker></mat-datepicker>
    }
</div>
